import React, { useState, useEffect, useRef } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { useRouter } from 'next/router'
import _ from 'lodash'
import { reactLocalStorage } from 'reactjs-localstorage'
import axios from 'axios'
import { Spinner } from 'baseui/spinner'
import Cookies from 'js-cookie'
import Classnames from 'classnames'
import RecoilOutside from 'recoil-outside'
import { RecoilRoot } from 'recoil'
import { opTitle, opDesc } from '@/utils/store/onepager_template'
import { layoutIds, layout } from '@/store/template/layout'
import { sectionIds, section } from '@/store/template/section'
import { contentIds, content, content_block } from '@/store/template/content'
import { settings, grid_matrix, explainer } from '@/store/template/settings'
import { design } from '@/store/template/design'
import { isBuilder } from '@/store/builder/store'
import { publicIsLoggedIn, currentTemplateID } from '@/store/onepager/onepager'
import Head from 'next/head'
import { ProvideOnepagerTemplate } from '@/utils/onepager-template'
import Hero from '@/components/onepager/Hero'
import DetailModal from '@/components/onepager/lists/DetailModal'
import ScrollLock from 'react-scrolllock'
import PublicGrid from '@/components/onepager/PublicGrid'
import PublicNav from '@/components/onepager/PublicNav'
import PublicSignUpModal from '@/components/onepager/PublicSignUpModal'
import PublicIntakeModal from '@/components/onepager/PublicIntakeModal'
import PublicShareModal from '@/components/onepager/PublicShareModal'
import PublicHelloBar from '@/components/onepager/PublicHelloBar'
import PublicLowerBanner from '@/components/onepager/PublicLowerBanner'
import PublicIntakeBanner from '@/components/onepager/PublicIntakeBanner'

function PublicOnepager({
  template,
  collection,
  isCollection,
  isTemplate,
  isAutoSignup,
  hasSignedUp,
  reloadSaveHistory,
}) {
  const router = useRouter()
  const [openCollectionSidebar, setOpenCollectionSidebar] =
    useState(isCollection)
  const [openSignUpModal, setOpenSignUpModal] = useState(false)
  const [openLoginModal, setOpenLoginModal] = useState(false)
  const [openShareModal, setOpenShareModal] = useState(false)
  const [helloBar, setHelloBar] = useState(collection.header_cta_link)
  const [signUpBar, setSignUpBar] = useState(true)
  const [isOnepagerForm, setIsOnepagerForm] = useState(false)
  const [hasSubmittedForm, setHasSubmittedForm] = useState(false)
  const [isTemplatePreview, setTemplatePreview] = useState(false)
  const [showRedirecting, setShowRedirecting] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0)

    // if (!router.query.preview) {
    //   axios.post('/api/wvtr', {
    //     id: template._id,
    //   })
    // }

    // check if collection.promoted
    // if (collection.promoted) {
    //   Cookies.set('promoted', true)
    // } else {
    //   Cookies.set('promoted', false)
    // }

    // check if form=true is set
    if (router.query.form) {
      setSignUpBar(false)
      setIsOnepagerForm(true)
      // remove submission-email cookie - reset on each load
      Cookies.remove('submission-email')
    }

    // check it is a template preview
    if (router.query.tmppreview) {
      setTemplatePreview(true)
    }

    // check if cookie autosignup is there, if so remove it
    // if (getUrlParameter('autosignup')) {
    //   reactLocalStorage.set('wl-email', getUrlParameter('autosignup'))
    // }
  }, [])

  // init values for recoil
  function initState({ set }) {
    set(isBuilder, false)

    // check if cookie wl-email (signed up with email)
    // check if cookie auth=true
    if (Cookies.get('wl-email')) {
      set(publicIsLoggedIn, true)
    }

    set(currentTemplateID, template._id)

    set(opTitle, template.title)
    set(opDesc, template.description)

    set(grid_matrix, template.grid_matrix)

    // settings & design
    if (template.settings) {
      try {
        set(settings, JSON.parse(template.settings))
      } catch (e) {
        set(settings, template.settings)
      }
    }
    if (template.design) {
      try {
        set(design, JSON.parse(template.design))
      } catch (e) {
        set(design, template.design)
      }
    }

    if (template.explainer) {
      try {
        set(explainer, JSON.parse(template.explainer))
      } catch (e) {
        set(explainer, template.explainer)
      }
    }

    // build layouts
    let allLayoutIds = []

    if (template.layout) {
      // _.forEach(JSON.parse(template.layout), function (layoutData) {
      //   allLayoutIds.push(layoutData.id)
      //   set(layout(layoutData.id), layoutData.atom)
      // })
      try {
        _.forEach(JSON.parse(template.layout), function (layoutData) {
          allLayoutIds.push(layoutData.id)
          set(layout(layoutData.id), layoutData.atom)
        })
      } catch (e) {
        _.forEach(template.layout, function (layoutData) {
          allLayoutIds.push(layoutData.id)
          set(layout(layoutData.id), layoutData.atom)
        })
      }
    }

    set(layoutIds, allLayoutIds)

    // build sections
    let allSectionIds = []

    // if (template.sections) {
    //   _.forEach(JSON.parse(template.sections), function (sectionData) {
    //     allSectionIds.push(sectionData.id)
    //     set(section(sectionData.id), sectionData.atom)
    //   })
    // }

    if (template?.sections) {
      try {
        _.forEach(JSON.parse(template.sections), function (sectionData) {
          allSectionIds.push(sectionData.id)
          set(section(sectionData.id), sectionData.atom)
        })
      } catch (e) {
        _.forEach(template.sections, function (sectionData) {
          allSectionIds.push(sectionData.id)
          set(section(sectionData.id), sectionData.atom)
        })
      }
    }

    set(sectionIds, allSectionIds)

    // LOADING FROM TEMPLATE

    // build contents
    let allContentIds = []

    // if (template.content) {
    //   _.forEach(JSON.parse(template.content), function (contentData) {
    //     allContentIds.push(contentData.id)
    //     set(content(contentData.id), contentData.atom)
    //   })
    // }

    if (template.content) {
      try {
        _.forEach(JSON.parse(template.content), function (contentData) {
          allContentIds.push(contentData.id)
          set(content(contentData.id), contentData.atom)
        })
      } catch (e) {
        _.forEach(template.content, function (contentData) {
          allContentIds.push(contentData.id)
          set(content(contentData.id), contentData.atom)
        })
      }
    }

    set(contentIds, allContentIds)

    // build content_blocks
    // if (template.content_blocks) {
    //   _.forEach(
    //     JSON.parse(template.content_blocks),
    //     function (contentBlockData) {
    //       set(content_block(contentBlockData.id), contentBlockData.atom)
    //     }
    //   )
    // }

    if (template?.content_blocks) {
      try {
        _.forEach(
          JSON.parse(template.content_blocks),
          function (contentBlockData) {
            set(content_block(contentBlockData.id), contentBlockData.atom)
          },
        )
      } catch (e) {
        _.forEach(template.content_blocks, function (contentBlockData) {
          set(content_block(contentBlockData.id), contentBlockData.atom)
        })
      }
    }
  }

  function getUrlParameter(parameterName) {
    var result = null,
      tmp = []
    location.search
      .substr(1)
      .split('&')
      .forEach(function (item) {
        tmp = item.split('=')
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
      })

    return result
  }

  // initializeState={initState}
  return (
    <RecoilRoot initializeState={initState}>
      <RecoilOutside />
      <Head>
        <title>{template.title}</title>
      </Head>
      <ProvideOnepagerTemplate>
        <div
          className={Classnames({
            'template-previewer': isTemplatePreview,
          })}
          style={{
            backgroundColor: 'var(--overall-bg-color)',
            scrollBehavior: 'smooth',
            paddingBottom: '30px',
          }}
        >
          {/* ONEPAGER BRANDED NAV */}
          {/* <PublicNav
            collection={collection}
            onepager={template}
            openSideBar={() => {
              setOpenCollectionSidebar(true)
            }}
            openSignUp={() => {
              setOpenSignUpModal(true)
            }}
            openShareModal={() => {
              setOpenShareModal(true)
            }}
            signUpBar={signUpBar}
            isOnepagerForm={isOnepagerForm}
            hasSubmittedForm={hasSubmittedForm}
            shouldRedirect={showRedirecting}
            isWizardLayout={false}
            reloadSaveHistory={() => {
              reloadSaveHistory()
            }}
          /> */}

          {showRedirecting && (
            <div
              className="fixed top-0 left-0 h-full w-full bg-white  flex flex-col items-center justify-center"
              style={{ zIndex: 99999999 }}
            >
              <Spinner color="#ffc900" />
              <h3 className="mt-5 text-2xl font-bold text-center">
                <span className="">Redirecting...</span>
                <span className="text-xs text-gray-500 pt-2 block">
                  You can come back this page to edit and tweak your answers at
                  anytime...
                </span>
              </h3>
            </div>
          )}

          {/* HELLOBAR BRANDED THING */}
          {/* <AnimatePresence initial={false} exitBeforeEnter>
            {helloBar && (
              <PublicHelloBar
                collection={collection}
                hideBar={() => {
                  setHelloBar(false)
                }}
              />
            )}
          </AnimatePresence> */}

          {/* HERO */}
          <AnimatePresence exitBeforeEnter>
            <Hero key="herobar" />
          </AnimatePresence>

          {/* GRID */}
          <AnimatePresence exitBeforeEnter>
            <PublicGrid onepager={template} collection={collection} />
          </AnimatePresence>

          {/* Collection Sidebar */}
          {/* <AnimatePresence initial={false} exitBeforeEnter>
            {openCollectionSidebar && (
              <PublicCollectionSideBar
                collection={collection}
                currentID={template._id}
                closeSidebar={() => {
                  setOpenCollectionSidebar(false)
                }}
              />
            )}
          </AnimatePresence>
          <ScrollLock isActive={openCollectionSidebar} /> */}

          {/* FOOTER */}
          <div className="flex justify-center pb-20">
            <div
              onClick={() => {
                window.open('https://onepager.io', '_blank')
                // analytics.track('Footer Onepager Link Public')
              }}
              className="font-bold mt-10 text-center bg-white hover:bg-yellow-100 shadow cursor-pointer  py-2 px-4 rounded text-opacity-75 relative"
              style={{ zIndex: '999' }}
            >
              <div className="flex items-center">
                <div>powered by</div>
                <img
                  className="mx-3 h-5"
                  src="https://cdn.filestackcontent.com/jW9hY5L5RAWWpn2rGhw9"
                  alt="onepager logo"
                />
                <div>onepager.io</div>
              </div>
            </div>
          </div>

          {/* LIST ITEM DETAIL VIEW */}
          <AnimatePresence exitBeforeEnter>
            <DetailModal />
          </AnimatePresence>
        </div>
      </ProvideOnepagerTemplate>
    </RecoilRoot>
  )
}

export default PublicOnepager
